export default "__VITE_ASSET__6c6587fc__"